export const DPD_SPECIAL_SERVICES = "dpdSpecialServices";
